module.exports = __webpack_public_path__ + "img/ED3.a9dc2e91.jpeg";